export default __webpack_public_path__ + "static/media/promos-icon-active.5078d96a.webp";